<template>
  <v-layout column :justify-space-between="$vuetify.breakpoint.xsOnly" :justify-start="$vuetify.breakpoint.smAndUp" fill-height>
    <v-fade-transition>
      <v-icon v-if="showArrow && !hideArrow" style="position: fixed; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 100;" large color="white">keyboard_arrow_down</v-icon>
    </v-fade-transition>
    <v-text-field
      :label="$t('tagId.label')"
      box
      dark
      class="flex-none"
      color="white"
      readonly
      prepend-inner-icon="nfc"
      :value="data.tagId"
      hide-details
    ></v-text-field>
    <v-flex class="py-3" :class="{'flex-none': $vuetify.breakpoint.smAndUp}">
      <div class="headline">{{$t('balance.current')}}</div>
      <div v-if="this.data.userData.balance < 0" class="display-1">0</div>
      <div v-else class="display-1">{{formattedBalance}}</div>
      <div v-if="data.userData && data.userData.refundable" class="headline">{{$t('balance.comission')}}</div>
      <div v-if="data.userData && data.userData.refundable" class="display-1 error--text">{{formattedTaxes}}</div>
      <div v-if="data.userData && data.userData.refundable" class="headline">{{$t('balance.total')}}</div>
      <div v-if="data.userData && data.userData.refundable" class="display-2" :class="totalClass">{{formattedTotal}}</div>
    </v-flex>
    <tip v-if="!data.userData.refundable" icon="error_outline" color="error" :text="data.userData.noRefundMessage[$i18n.locale]"/>
    <v-flex v-else class="flex-none pa-0">
      <v-btn :loading="state.loading" style="float: right" :block="$vuetify.breakpoint.xsOnly" color="secondary blue-grey--text text--darken-2" round large :class="{'mt-5': $vuetify.breakpoint.smAndUp}" @click="nextStep()">{{$t('balance.refund')}}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import routeNames from '@/router/route-names'
import { mapState } from 'vuex'
import ResponsivityMixins from '@/mixins/Responsivity'

export default {
  data () {
    return {
      routeNames
    }
  },
  mixins: [
    ResponsivityMixins
  ],
  components: {
    Tip: () => import('@/components/Tip.vue')
  },
  mounted () {
    this.$nextTick(() => {
      this.hasScrollbar()
    })
  },
  methods: {
    pad (str) {
      str = str.toString()
      return str.length < 2 ? this.pad('0' + str) : str
    },
    nextStep () {
      this.$emit('nextStep')
    }
  },
  computed: {
    ...mapState(['state', 'data', 'configuration']),
    formattedBalance () {
      return `${Math.trunc(this.data.userData.balance / 100)}${this.$t('decimal_separator')}${this.pad(this.data.userData.balance % 100)} ${this.configuration.configuration.currency}`
    },
    formattedTaxes () {
      return `-${Math.trunc(this.data.userData.comission / 100)}${this.$t('decimal_separator')}${this.pad(this.data.userData.comission % 100)} ${this.configuration.configuration.currency}`
    },
    formattedTotal () {
      return `${Math.trunc(this.data.userData.refundableBalance / 100)}${this.$t('decimal_separator')}${this.pad(this.data.userData.refundableBalance % 100)} ${this.configuration.configuration.currency}`
    },
    totalClass () {
      return (this.data.userData.balance - this.data.userData.comission) < 0 ? 'error--text' : ''
    }
  }
}
</script>
